<template>
  <div aria-label="Breadcrumb">
    <ol
      role="list"
      class="flex flex-wrap items-start"
    >
      <li
        v-for="page in pages"
        :key="page.name"
      >
        <div class="flex items-center">
          <NuxtLink
            :to="page.href"
            :class="getLinkClasses(page)"
            :aria-current="page.current ? 'page' : undefined"
          >{{ page.name }}</NuxtLink>
          <ChevronRightSmall
            v-if="!page.current"
            custom-style="flex-shrink-0 h-5 w-5 text-gray-400"
          />
        </div>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumb',
  props: {
    pages: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getLinkClasses(page) {
      return [
        'whitespace-nowrap text-sm font-light',
        page.current ? 'text-theme-accent' : 'text-gray-500',

        { 'mr-1': !page.current },
        /**
         * This is an edge case handling where we want to translate all breadcrumbs EXCEPT those which denotes the pattern of
         * LETTER-NUMBER-NUMBER as this matches the question index pages for Reporting.
         */
        { 'no-localize-translate': this.shouldNotLocalize(page.name) },
      ]
    },
    shouldNotLocalize(name) {
      return /^[A-Z]-\d+-\d+$/.test(name)
    },
  },
}
</script>
